import {
  createApiRef,
  DiscoveryApi,
  FetchApi,
  IdentityApi,
} from '@backstage/core-plugin-api';
import type { ResolvedImageBuild } from '../components/scaffolder/portalImageTypes';

export type ResolveImageBuildRequest = {
  source_repo_url: string;
  source_repo_ref: string;
  clone_token?: string;
};

export type PortalImageApi = {
  resolveBuild(input: ResolveImageBuildRequest): Promise<ResolvedImageBuild>;
};

export const portalImageApiRef = createApiRef<PortalImageApi>({
  id: 'plugin.portal-image.service',
});

export class PortalImageClient implements PortalImageApi {
  constructor(
    private readonly discoveryApi: DiscoveryApi,
    private readonly fetchApi: FetchApi,
    private readonly identityApi: IdentityApi,
  ) {}

  async resolveBuild(
    input: ResolveImageBuildRequest,
  ): Promise<ResolvedImageBuild> {
    const baseUrl = await this.discoveryApi.getBaseUrl('portal-image');
    const { token } = await this.identityApi.getCredentials();
    const response = await this.fetchApi.fetch(`${baseUrl}/resolve-build`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify(input),
    });

    if (!response.ok) {
      const body = await response.json().catch(() => ({}));
      throw new Error(
        (body as { error?: string }).error ??
          `Failed to resolve image build (${response.status})`,
      );
    }

    return response.json() as Promise<ResolvedImageBuild>;
  }
}
